var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "tab-container"
  }, [_c('div', {
    staticClass: "recipe-area"
  }, [_c('div', {
    staticClass: "panel-wrapper"
  }, [_c('div', {
    staticClass: "sales-panel"
  }, [_c('div', {
    staticClass: "panel-header"
  }, [_c('h3', [_vm._v("销售项目")]), _c('div', [_vm.selectedSale ? _c('Button', {
    staticStyle: {
      "margin-right": "15px"
    },
    on: {
      "click": function ($event) {
        return _vm.$refs.SACSalesDrawer.openDrawer(_vm.selectedSale);
      }
    }
  }, [_vm._v("编辑销售项目")]) : _vm._e(), _c('Button', {
    on: {
      "click": function ($event) {
        return _vm.$refs.SACSalesDrawer.openDrawer();
      }
    }
  }, [_vm._v("添加销售项目")])], 1)]), _c('div', {
    staticClass: "table"
  }, _vm._l(_vm.salesList, function (e, index) {
    return _c('div', {
      key: index,
      class: {
        'sales-card': true,
        'selected': _vm.selectedSalesId === e._id
      },
      on: {
        "click": function ($event) {
          return _vm.selectSales(e);
        }
      }
    }, [_c('div', [_vm._v(_vm._s(e.customer.name) + " — " + _vm._s(e.material.name) + " — " + _vm._s(e.name))]), _c('div', [_vm._v(_vm._s(e.NoId))])]);
  }), 0)]), _c('div', {
    staticClass: "sales-panel"
  }, [_c('div', {
    staticClass: "panel-header"
  }, [_c('h3', [_vm._v("配方列表")]), _c('div', [_vm.selectedRecipeId ? _c('Button', {
    staticStyle: {
      "margin-right": "15px"
    },
    on: {
      "click": function ($event) {
        return _vm.$refs.SACRecipeDrawer.openDrawer(_vm.selectedSalesId, _vm.selectedRecipe);
      }
    }
  }, [_vm._v("编辑配方")]) : _vm._e(), _vm.selectedSalesId ? _c('Button', {
    on: {
      "click": function ($event) {
        return _vm.$refs.SACRecipeDrawer.openDrawer(_vm.selectedSalesId);
      }
    }
  }, [_vm._v("创建配方")]) : _vm._e()], 1)]), _vm.selectedSalesId ? _c('div', {
    staticClass: "sales-table"
  }, _vm._l(_vm.recipeList, function (e, index) {
    return _c('div', {
      key: index,
      class: {
        'sales-card': true,
        'selected': _vm.selectedRecipeId === e._id
      },
      on: {
        "click": function ($event) {
          return _vm.selectRecipe(e._id);
        }
      }
    }, [_c('div', [_vm.selectedSalesprodRecipeId === e._id ? _c('span', {
      staticClass: "prod-tag"
    }, [_vm._v("生产配方")]) : _vm._e(), _vm._v(" " + _vm._s(e.name || '-') + " ")])]);
  }), 0) : _vm._e()]), _c('div', {
    staticClass: "recipe-panel"
  }, [_vm._m(0), _vm.selectedRecipeId ? _c('div', {
    staticClass: "recipe-table"
  }, [_c('Table', {
    attrs: {
      "columns": _vm.recipeColumns,
      "data": _vm.selectedRecipeDetail,
      "border": "",
      "show-summary": "",
      "summary-method": _vm.handleSummary
    }
  })], 1) : _vm._e()])])]), _c('SACRecipeDrawer', {
    ref: "SACRecipeDrawer",
    on: {
      "updatedGetRecipe": _vm.updatedGetRecipe,
      "editSuccess": _vm.loadSacDetail
    }
  }), _c('SACSalesDrawer', {
    ref: "SACSalesDrawer",
    on: {
      "editSuccess": _vm.loadSacDetail
    }
  })], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "panel-header"
  }, [_c('h3', [_vm._v("配方详情")])]);

}]

export { render, staticRenderFns }